import { z } from "zod";

/** Username rules shared by sign-up and profile edit (see design doc). */
export const USERNAME_MIN = 3;
export const USERNAME_MAX = 20;
export const USERNAME_RE = /^[a-z0-9_]+$/;

/** Days a freed username stays reserved against other users. */
export const USERNAME_RESERVATION_DAYS = 90;

/** Days a user must wait between username changes (server cooldown + edit UI). */
export const USERNAME_COOLDOWN_DAYS = 30;

export const usernameSchema = z
  .string()
  .min(USERNAME_MIN, `At least ${USERNAME_MIN} characters.`)
  .max(USERNAME_MAX, `At most ${USERNAME_MAX} characters.`)
  .regex(USERNAME_RE, "Lowercase letters, numbers and _ only.");
